<template>
  <v-container>
    <v-combobox
      v-model="user.health.ancestry.maternal"
      :items="ancestryQuestion"
      label="Maternal Ancestry"
      multiple
      outlined
      dense
      chips></v-combobox>
    <v-combobox
      v-model="user.health.ancestry.paternal"
      :items="ancestryQuestion"
      label="Paternal Ancestry"
      multiple
      outlined
      dense
      chips></v-combobox>
  </v-container>
</template>


<script>
import { mapFields } from "vuex-map-fields";
export default {
  props: {
  },
  mounted () {
  },
  methods: {
  },
  data () {
    return {
    };
  },
  computed: {
    ...mapFields("patientQuestion", [
      "ancestryQuestion"
    ]),
    ...mapFields([
      "user"
    ])
  }
};
</script>
<style>
.condCard {
  padding: 20px;
  margin: 5px;
}
.padded {
  margin: 5px 5px 5px 5px;
}
</style>
